export default __webpack_public_path__ + "static/Letter_of_Recommendation-530f30f4e146b7aa57d26f551498a398.pdf";